import {
    AwesomeTableComponent,
    HeaderTable,
    IColumnsProps,
    TimeUtils,
    useFirstTime,
    ViewLabelStatus,
} from "d-react-components";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { JsonParam, useQueryParam } from "use-query-params";
import StockAdjustmentAPI from "../../../../api/queries/stock-adjustment";
import AppLink from "../../../../common/AppLink";
import { STOCK_ADJUSTMENT_STATUSES } from "../../../../constant/stock-adjustment";
import Messages from "../../../../languages/Messages";
import Path from "../../../Path";
import StockAdjustmentFilterDrawer from "./StockAdjustmentFilterDrawer";

const StockAdjustmentTable = () => {
    const tableRef = useRef<any>(null);
    const searchRef = useRef<string>("");
    const navigate = useNavigate();
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useQueryParam<any>("filter", JsonParam);
    const isFirstTime = useFirstTime();

    useEffect(() => {
        if (isFirstTime) return;
        tableRef.current.refresh();
    }, [filter]);

    const columns: IColumnsProps = [
        {
            title: "ID",
            dataIndex: "adjustmentNo",
            render: (adjustmentNo, item) => (
                <AppLink
                    to={generatePath(Path.INVENTORY_STOCK_ADJUSTMENT_DETAIL, {
                        stockAdjustmentId: item.id,
                    })}
                >
                    {adjustmentNo}
                </AppLink>
            ),
        },
        {
            title: Messages.branchWarehouse,
            dataIndex: "branch",
            render: (branch) => branch?.name,
        },
        {
            title: Messages.status,
            dataIndex: "status",
            render: (data) => (
                <ViewLabelStatus
                    status={data}
                    listStatus={STOCK_ADJUSTMENT_STATUSES}
                    getLabel={(item) => (Messages as any)[item.label]}
                />
            ),
        },
        {
            title: Messages.createdAt,
            dataIndex: "createdAt",
            render: TimeUtils.toDateTime,
        },
    ];

    const source = (pagingData: any) => {
        // const filterParam = mapBookingFilterToServer(filter);
        const input = {
            page: pagingData.pageIndex,
            limit: pagingData.pageSize,
            sort: { createdAt: 1 },
            // ...filterParam,
        };
        return StockAdjustmentAPI.list(input);
    };

    const onClickTableAction = (actionId: string, booking: any) => {
        switch (actionId) {
            default:
                navigate(
                    generatePath(Path.BOOKING_DETAIL, {
                        bookingId: booking.id,
                    })
                );
        }
    };

    const onClickAddNew = () => {
        navigate(Path.INVENTORY_STOCK_ADJUSTMENT_CREATE);
    };

    const onChangeSearch = debounce((text) => {
        searchRef.current = text;
        tableRef.current.refresh();
    }, 500);

    return (
        <div className="">
            <HeaderTable
                onClickNew={onClickAddNew}
                label={Messages.allStockAdjustmentRequest}
                onClickFilter={() => setOpenFilter(true)}
                onChangeText={(event: any) =>
                    onChangeSearch(event.target.value)
                }
                className="app-layout__page-header"
            />
            <AwesomeTableComponent
                ref={(ref) => {
                    tableRef.current = ref;
                }}
                source={source}
                columns={columns}
                showSelectColumn
                baseColumnProps={{ width: 100 }}
                getTotalItems={(res) => {
                    return res?.pagination?.items ?? 0;
                }}
                transformer={(res) => res?.data ?? []}
            />
            {openFilter && (
                <StockAdjustmentFilterDrawer
                    open={openFilter}
                    onClose={() => setOpenFilter(false)}
                />
            )}
        </div>
    );
};

export default StockAdjustmentTable;
